class o {
  constructor(e = {}) {
    this.resolvedTheme = "light";
    const {
      storageKey: t = "solanda-ui-theme",
      defaultTheme: s = "system",
      defaultPreset: r = "solanda",
      autoApply: a = !0
    } = e;
    this.storageKey = t, this.presetStorageKey = `${t}-preset`, this.theme = s, this.preset = r, this.resolvedTheme = this.resolveTheme(s), a && typeof document < "u" && this.apply();
  }
  resolveTheme(e) {
    return e === "system" && typeof window < "u" ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : e;
  }
  apply() {
    typeof document > "u" || (this.resolvedTheme = this.resolveTheme(this.theme), document.documentElement.classList.remove(
      "dark",
      "sl-light",
      "sl-dark",
      "theme-solanda",
      "theme-social-neutral",
      "theme-catppuccin",
      "theme-gruvbox",
      "theme-tokyo-night",
      "theme-nord"
    ), this.resolvedTheme === "dark" && document.documentElement.classList.add("dark"), document.documentElement.classList.add(`theme-${this.preset}`), typeof localStorage < "u" && (localStorage.setItem(this.storageKey, this.theme), localStorage.setItem(this.presetStorageKey, this.preset)));
  }
  getTheme() {
    return this.theme;
  }
  getResolvedTheme() {
    return this.resolvedTheme;
  }
  getPreset() {
    return this.preset;
  }
  setTheme(e) {
    this.theme = e, this.apply();
  }
  setPreset(e) {
    this.preset = e, this.apply();
  }
  toggleTheme() {
    const e = this.resolvedTheme === "light" ? "dark" : "light";
    this.setTheme(e);
  }
  static init(e) {
    const t = new o(e);
    if (typeof window < "u" && typeof localStorage < "u") {
      const s = localStorage.getItem(e?.storageKey || "solanda-ui-theme");
      s && (t.theme = s);
      const r = localStorage.getItem(`${e?.storageKey || "solanda-ui-theme"}-preset`);
      r && ["solanda", "social-neutral", "catppuccin", "gruvbox", "tokyo-night", "nord"].includes(r) && (t.preset = r), t.apply();
    }
    return typeof window < "u" && window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
      t.theme === "system" && t.apply();
    }), t;
  }
}
const i = o.init();
export {
  o as ThemeManager,
  i as default,
  i as themeManager
};
//# sourceMappingURL=theme-manager.js.map
